import styled from 'styled-components'
import { shimmerAnim } from '../../../utils'

const StyledCourseList = styled.div`
  display: grid;
  gap: 40px;

  .skel {
    display: grid;
    gap: 24px;
    overflow: hidden;

    & > div:nth-child(1) {
      padding-top: 56.25%;
      border-radius: 10px;
      animation: ${shimmerAnim} 1.4s ease-in-out infinite;
    }

    & > div:nth-child(2) {
      display: grid;
      overflow: hidden;
      align-content: space-between;
      gap: 20px;
      justify-items: start;

      & > div:nth-child(1) {
        overflow: hidden;
        width: 100%;

        div:nth-child(1) {
          height: 20px;
          width: 300px;
          max-width: 100%;
          border-radius: 6px;
          animation: ${shimmerAnim} 1.4s ease-in-out infinite;
        }

        div:nth-child(2) {
          height: 18px;
          width: 200px;
          margin-top: 8px;
          border-radius: 6px;
          animation: ${shimmerAnim} 1.4s ease-in-out infinite;
        }
      }

      & > div:nth-child(2) {
        height: 50px;
        width: 190px;
        border-radius: 8px;
        animation: ${shimmerAnim} 1.4s ease-in-out infinite;
      }
    }

    @media (min-width: 600px) {
      grid-template-columns: 300px minmax(0, 1fr);

      & > div:nth-child(2) {
        gap: 0;
      }
    }
  }
`

export default StyledCourseList
